// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1jnh0","menu__inner":"Menu_menu__inner__3fBOU","menu__logo":"Menu_menu__logo__1E4iQ"};